/* PUSHAS 2026 — Size filter clean-up, plus small header and cart corrections.

   Size facet: it mixes apparel sizes, adult footwear, youth sizes and a tail of
   data errors in one 50+ row list, one full-width row each. This groups them,
   lays them out as a chip grid, swaps the long "US M 8 / W 9-9.5" label for a
   Men's/Women's toggle, and hides values that are conditions rather than sizes.
   Purely presentational: the theme's own inputs, names and values are untouched,
   so filtering and the back button behave exactly as before.

   Header search: shortens the placeholder (the long one truncated inside the
   236px pill) and pads the field so the caret starts inside the pill.

   Cart: adds a Shipping row under Subtotal reading "Determined at checkout", so
   the shipping cost is not a surprise at the payment step. */
(function () {
  'use strict';
  var STORE = 'p26f-gender';
  var CSS =
    /* header search field */
    '.header__search-full .field .search__input,.search-modal__form .field .search__input,.header__search-input .field .search__input{padding-left:18px!important;padding-right:10px!important}' +
    /* size facet */
    '.p26f .facets__list{display:grid!important;grid-template-columns:repeat(auto-fill,minmax(54px,1fr));gap:6px;padding:0!important;margin:0!important;max-height:none!important;overflow:visible!important}' +
    '.p26f .facets__item{display:block!important;margin:0!important;padding:0!important;border:0!important;width:auto!important;float:none!important}' +
    /* the theme caps the list at 20 items by setting inline opacity:0 on the rest —
       the grid makes the full list short enough to show, so bring them all back */
    '.p26f .facets__item:not([data-p26g="junk"]){opacity:1!important;visibility:visible!important;height:auto!important}' +
    '.p26f .facets__item input{position:absolute!important;opacity:0!important;width:0;height:0;pointer-events:none}' +
    '.p26f .facets__item label.facet-checkbox{display:flex!important;align-items:center;justify-content:center;height:34px;padding:0 6px!important;margin:0!important;border:1px solid #e6e6e6;border-radius:9px;font-size:12.5px;font-weight:600;line-height:1;color:#111;cursor:pointer;white-space:nowrap;transition:border-color .15s,background .15s,color .15s}' +
    '.p26f .facets__item label.facet-checkbox:hover{border-color:#111}' +
    '.p26f .facets__item label.facet-checkbox::before,.p26f .facets__item label.facet-checkbox::after{display:none!important}' +
    '.p26f .facets__item input:checked+label.facet-checkbox{background:#111;border-color:#111;color:#fff}' +
    '.p26f [data-p26g="junk"]{display:none!important}' +
    '.p26f [data-p26g="other"]{grid-column:1/-1}' +
    '.p26f [data-p26g="other"] label.facet-checkbox{justify-content:flex-start;padding:0 12px!important;font-weight:500;color:#555}' +
    '.p26f .p26f-head{grid-column:1/-1;list-style:none;font-size:10.5px;font-weight:700;letter-spacing:.12em;text-transform:uppercase;color:#9a9a9a;margin:14px 0 2px}' +
    '.p26f .p26f-head.is-first{margin-top:0}' +
    '.p26f .p26f-gender{grid-column:1/-1;list-style:none;display:flex;padding:3px;border-radius:999px;background:#f1f1f1;margin:0 0 4px}' +
    '.p26f .p26f-gender button{flex:1;height:28px;border:0;border-radius:999px;background:transparent;font:inherit;font-size:11.5px;font-weight:700;color:#777;cursor:pointer}' +
    '.p26f .p26f-gender button[aria-pressed="true"]{background:#111;color:#fff}' +
    '.p26f .facets__show-more,.p26f .show-more,.p26f .facet-show-more,.p26f [class*="show-more"]{display:none!important}';

  function injectCss() {
    if (document.getElementById('p26f-style')) return;
    var s = document.createElement('style');
    s.id = 'p26f-style';
    s.textContent = CSS;
    (document.head || document.documentElement).appendChild(s);
  }

  /* pushas-2026.js sets a longer hint; one word is all that fits the pill */
  function searchPlaceholder() {
    var sel = '.header__search-full .search__input, .search-modal__form .search__input, .header__search-input .search__input';
    var inputs = document.querySelectorAll(sel);
    for (var i = 0; i < inputs.length; i++) {
      if (inputs[i].getAttribute('placeholder') !== 'Search') inputs[i].setAttribute('placeholder', 'Search');
    }
  }

  /* Shipping line under Subtotal so the cost is flagged before checkout */
  function cartShipping() {
    var lists = document.querySelectorAll('.cart-totals');
    for (var i = 0; i < lists.length; i++) {
      var ul = lists[i];
      if (ul.querySelector('.p26-cart-ship')) continue;
      var sub = ul.querySelector('.cart-total-subtotal');
      if (!sub || !sub.parentNode) continue;
      var li = document.createElement('li');
      li.className = 'cart-total p26-cart-ship';
      li.innerHTML = '<div class="cart-total-label"><span class="text">Shipping</span></div>' +
                     '<div class="cart-total-value"><span class="text">Determined at checkout</span></div>';
      sub.parentNode.insertBefore(li, sub.nextSibling);
    }
  }

  var APPAREL = /^(one size|2xs|xs|s|m|l|xl|2xl|3xl|4xl)$/i;
  var JUNK = /damaged/i;
  var YOUTH = /^([\d.]+)\s*Y$/i;
  var FOOT = /^US\s*M(?:ens)?\.?\s*([\d.]+)/i;
  var WOMENS = /W\s*([\d.]+(?:\s*-\s*[\d.]+)?)/i;

  function head(text, first) {
    var e = document.createElement('li');
    e.className = 'p26f-head' + (first ? ' is-first' : '');
    e.textContent = text;
    return e;
  }

  function paint(ul, g) {
    var btns = ul.querySelectorAll('.p26f-gender button');
    for (var i = 0; i < btns.length; i++) {
      btns[i].setAttribute('aria-pressed', String(btns[i].getAttribute('data-g') === g));
    }
    var foot = ul.querySelectorAll('[data-p26g="foot"]');
    for (var j = 0; j < foot.length; j++) {
      var it = foot[j];
      var sp = it.querySelector('.text');
      if (!sp) continue;
      sp.textContent = g === 'w' ? it.getAttribute('data-w') : it.getAttribute('data-m');
      var lb = it.querySelector('label');
      if (lb) {
        lb.setAttribute('title', it.getAttribute('data-orig'));
        lb.setAttribute('aria-label', it.getAttribute('data-orig'));
      }
    }
  }

  function gender() {
    try { return localStorage.getItem(STORE) === 'w' ? 'w' : 'm'; } catch (e) { return 'm'; }
  }

  function enhance(ul) {
    if (!ul || ul.getAttribute('data-p26f')) return;
    var items = [].slice.call(ul.querySelectorAll('li'));
    if (items.length < 12) return;

    var foot = [], youth = [], apparel = [], other = [], junk = [], seen = {}, found = false;

    items.forEach(function (it) {
      var sp = it.querySelector('.text');
      if (!sp) return;
      var t = (it.getAttribute('data-orig') || sp.textContent).replace(/\s+/g, ' ').trim();
      it.setAttribute('data-orig', t);
      if (JUNK.test(t)) { it.setAttribute('data-p26g', 'junk'); junk.push(it); return; }
      var m = t.match(FOOT);
      if (m) {
        if (seen[m[1]]) { it.setAttribute('data-p26g', 'other'); other.push(it); return; }
        seen[m[1]] = 1;
        found = true;
        var w = t.match(WOMENS);
        it.setAttribute('data-p26g', 'foot');
        it.setAttribute('data-m', m[1]);
        it.setAttribute('data-w', w ? w[1].replace(/\s*-\s*/, '–') : m[1]);
        foot.push(it);
        return;
      }
      if (YOUTH.test(t)) { it.setAttribute('data-p26g', 'youth'); youth.push(it); return; }
      if (APPAREL.test(t)) { it.setAttribute('data-p26g', 'apparel'); apparel.push(it); return; }
      it.setAttribute('data-p26g', 'other');
      other.push(it);
    });

    if (!found) return;

    foot.sort(function (a, b) { return parseFloat(a.getAttribute('data-m')) - parseFloat(b.getAttribute('data-m')); });
    youth.sort(function (a, b) { return parseFloat(a.getAttribute('data-orig')) - parseFloat(b.getAttribute('data-orig')); });

    var g = gender();
    var frag = document.createDocumentFragment();

    frag.appendChild(head('Footwear (US)', true));
    var tog = document.createElement('li');
    tog.className = 'p26f-gender';
    tog.innerHTML = '<button type="button" data-g="m" aria-pressed="' + (g === 'm') + '">Men\'s</button>' +
                    '<button type="button" data-g="w" aria-pressed="' + (g === 'w') + '">Women\'s</button>';
    frag.appendChild(tog);
    foot.forEach(function (e) { frag.appendChild(e); });
    if (youth.length) { frag.appendChild(head('Youth')); youth.forEach(function (e) { frag.appendChild(e); }); }
    if (apparel.length) { frag.appendChild(head('Apparel')); apparel.forEach(function (e) { frag.appendChild(e); }); }
    if (other.length) { frag.appendChild(head('Other')); other.forEach(function (e) { frag.appendChild(e); }); }
    junk.forEach(function (e) { frag.appendChild(e); });

    ul.appendChild(frag);
    ul.setAttribute('data-p26f', '1');

    var wrap = ul.closest('.facets__wrapper') || ul.closest('.collection-filters__item') || ul.closest('.sidebarBlock') || ul.parentElement;
    if (wrap) wrap.classList.add('p26f');

    paint(ul, g);

    tog.addEventListener('click', function (e) {
      var b = e.target.closest ? e.target.closest('button[data-g]') : null;
      if (!b) return;
      var ng = b.getAttribute('data-g');
      try { localStorage.setItem(STORE, ng); } catch (err) {}
      var all = document.querySelectorAll('ul[data-p26f]');
      for (var i = 0; i < all.length; i++) paint(all[i], ng);
    });
  }

  function run() {
    injectCss();
    searchPlaceholder();
    cartShipping();
    var uls = document.querySelectorAll('ul');
    for (var i = 0; i < uls.length; i++) {
      if (uls[i].querySelector('input[name="filter.v.option.size"]')) enhance(uls[i]);
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();

  var t;
  new MutationObserver(function () {
    clearTimeout(t);
    t = setTimeout(run, 120);
  }).observe(document.documentElement, { childList: true, subtree: true });
})();